import React from 'react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { rememberItems } from '../../data/content';
export function Remember() {
  return <section className="w-full bg-cream py-14 sm:py-20" data-id="element-264" data-mp="qe3bhwzyl8gs">
      <div className="mx-auto w-full max-w-5xl px-4" data-id="element-265" data-mp="qfmqlk9vpdgz">
        <SectionHeading eyebrow="The real problem" title="How many things do you have to remember during an aligner treatment?" data-id="element-266" data-mp="ln3hazi854hz" />

        <ul className="mx-auto mt-8 grid w-full max-w-3xl grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-3" data-id="element-267" data-mp="10elyv1qqf73g">
          {rememberItems.map(item => <li key={item} className="rounded-xl border border-navy-100 bg-white px-3 py-3 text-center text-sm font-semibold text-navy-700 sm:text-base" data-id="element-268" data-mp="19dh9cq0t73ck">
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-navy-600 sm:text-lg" data-id="element-269" data-mp="3b6drsxx1t86p">
          And when everything depends on your memory, it is easy to feel like
          you are managing too many variables at once.
        </p>

        <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-navy-800 p-6 text-center sm:p-10" data-id="element-270" data-mp="ev5scggaywm0">
          <h3 className="font-display text-2xl font-black uppercase leading-tight text-white sm:text-3xl" data-id="element-271" data-mp="jsp6zhgwxbeh">
            What if you could organize the case first?
          </h3>
          <p className="mt-4 text-base leading-relaxed text-navy-100" data-id="element-272" data-mp="tk1yg7ystzjz">
            That is exactly what ALIGNER CONTROL SYSTEM™ was designed for.
            Instead of another long ebook filled with information, you get a
            structured system that helps you organize the key stages of an
            aligner case.
          </p>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-2 gap-y-2" data-id="element-273" data-mp="17ia2t0y60356">
            {['Assess', 'Plan', 'Prepare', 'Install', 'Control', 'Refine'].map((stage, i) => <React.Fragment key={stage} data-id="element-274" data-mp="39aoevje12ddo" data-mpi={i}>
                  {i > 0 && <span className="text-sky-400" aria-hidden="true" data-id="element-275" data-mp="31ai76b0lbhof">
                      →
                    </span>}
                  <span className="rounded-lg bg-white/10 px-2.5 py-1.5 text-xs font-extrabold uppercase tracking-wide text-white sm:text-sm" data-id="element-276" data-mp="2xahp8gea8ocm">
                    {stage}
                  </span>
                </React.Fragment>)}
          </div>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-277" data-mp="3k6hz5ltkil80">
          <CTAButton label="Get the complete system" data-id="element-278" data-mp="3g7snpys3bdr0" />
        </div>
      </div>
    </section>;
}